import React from 'react';
import { Icon } from 'ui';

const attendanceText = (attendance, pastEvent) => {
  if (pastEvent) {
    return attendance.did_attend || attendance.didAttend
      ? t('in_person_training.attendance.phrase.did_attend')
      : t('in_person_training.attendance.phrase.did_not_attend');
  }
  return attendance.rsvp_status === 'will_attend' ||
    attendance.rsvpStatus === 'will_attend'
    ? t('in_person_training.attendance.phrase.will_attend')
    : t('in_person_training.attendance.phrase.will_not_attend');
};

const AttendanceStatus = ({
  attendance,
  pastEvent,
  showSessionAtCapacityNotice = false,
}) => {
  let statusClass;
  let statusText;
  let statusIcon;

  if (showSessionAtCapacityNotice) {
    statusIcon = 'info';
    statusClass = 'blue';
    statusText = t('in_person_training.attendance.phrase.at_capacity');
  } else {
    const status = pastEvent
      ? attendance.did_attend || attendance.didAttend
      : attendance.rsvp_status === 'will_attend' ||
        attendance.rsvpStatus === 'will_attend';
    if (status) {
      statusClass = 'attending';
      statusIcon = 'correct';
    } else {
      statusClass = 'notAttending';
      statusIcon = 'incorrect';
    }

    statusText = attendanceText(attendance, pastEvent);
  }

  return (
    <>
      <div
        className={`EventRegistration-AttendanceStatus
        EventRegistration-AttendanceStatus--${statusClass}
        mr-16
        `}
      >
        <Icon name={statusIcon} className="EventRegistration-AttendanceIcon" />
        {statusText}
      </div>
    </>
  );
};

export default AttendanceStatus;
